import React from "react";
import { useMediaQuery } from "react-responsive";
import { GlobalContext } from "../../../context/GlobalState";
import { ReactComponent as Loader } from "../../../images/analytics/ChartLoader.svg";

import AnalyticsHeader from "../components/AnalyticsHeader";
import AnalyticsSection from "../components/AnalyticsSection";
import AnalyticsGrid from "../components/AnalyticsGrid";
import ViewReportLink from "./components/ViewReportLink";

import SideBoard from "../SideBoard/SideBoard";
import MiniCards from "./components/MiniCards";
import Table from "./Table/Table";

import LearningStrength from "./Charts/Learning_Strength";
import QuestionAttemptsPie from "./Charts/QuestionAttempsPie";
import ProgressReport from "./Charts/ProgressReport";
import QuestionStatusReport from "./Charts/QuestionStatusReport";
import DifficultyReport from "./Charts/DifficultyReport";
import CognitiveReport from "./Charts/CognitiveReport";

import useAssessmentAnalytics from "./hooks/useAssessmentAnalytics";

function AssessmentAnalytics() {
  const isSmall = useMediaQuery({ query: "(max-width: 472px)" });
  const { userDetails } = React.useContext(GlobalContext);
  const sectionId = window.localStorage.getItem("sectionId");

  const [filterData, setFilterData] = React.useState({
    subjectId: "",
    chapterId: "",
    topicId: "",
  });

  const analytics = useAssessmentAnalytics({
    sectionId,
    userId: userDetails.userId,
    filterData,
  });

  return (
    <>
      <SideBoard levels={["subject", "chapter"]} filterData={filterData} setFilterData={setFilterData} />

      <AnalyticsSection>
        {!isSmall && <AnalyticsHeader title={"Analytics"} subtitle={"Practice Assessment Overview"} />}
        <br />
        {analytics.learning.loading ? (
          <Loader />
        ) : (
          <>
            <MiniCards data={analytics.practice.data} />
            <br />
            <AnalyticsGrid>
              <LearningStrength
                data={analytics.learning.data}
                loading={analytics.learning.loading}
              />

              <QuestionAttemptsPie
                data={analytics.statusPie.data}
                loading={analytics.statusPie.loading}
              />

              <ProgressReport
                data={analytics.progress.data}
                loading={analytics.progress.loading}
              />
              <QuestionStatusReport
                data={analytics.status.data}
                loading={analytics.status.loading}
              />

              <DifficultyReport
                data={analytics.difficulty.data}
                loading={analytics.difficulty.loading}
              />

              <CognitiveReport
                data={analytics.cognitive.data}
                loading={analytics.cognitive.loading}
              />
            </AnalyticsGrid>
            <br />
            {/*<ViewReportLink subjectId={filterData.subjectId} />*/}
            <br />
            <Table title="Practice Report of All Subjects" />
          </>
        )}
      </AnalyticsSection>
    </>
  );
}

export default AssessmentAnalytics;
